import { CheckCircle2 } from 'lucide-react';

function formatLabel(key: string): string {
  return key
    .replace(/([A-Z])/g, ' $1')
    .replace(/_/g, ' ')
    .trim()
    .split(' ')
    .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
    .join(' ');
}

export function MilestonesCard({ milestones }: { milestones: Record<string, boolean> }) {
  const entries = Object.entries(milestones);

  return (
    <div className="bg-card border border-border rounded-lg p-6">
      <div className="flex items-center gap-3 mb-4">
        <div className="w-10 h-10 rounded-lg bg-green-50 dark:bg-green-950 flex items-center justify-center">
          <CheckCircle2 className="w-5 h-5 text-green-600 dark:text-green-400" />
        </div>
        <div>
          <h3 className="text-lg font-semibold text-foreground">Milestones</h3>
          <p className="text-xs text-muted-foreground">Job progress tracking</p>
        </div>
      </div>

      <div className="space-y-2">
        {entries.map(([key, value], idx) => (
          <div key={key} className="flex items-center gap-3">
            <div className="flex flex-col items-center">
              {value ? (
                <CheckCircle2 className="w-5 h-5 text-green-600 flex-shrink-0" />
              ) : (
                <div className="w-5 h-5 rounded-full border-2 border-slate-300 dark:border-slate-600 flex-shrink-0" />
              )}
              {idx < entries.length - 1 && (
                <div
                  className={`w-0.5 h-4 mt-1 ${value ? 'bg-green-300 dark:bg-green-700' : 'bg-slate-200 dark:bg-slate-700'}`}
                />
              )}
            </div>
            <span
              className={`text-sm font-medium ${value ? 'text-foreground' : 'text-muted-foreground'}`}
            >
              {formatLabel(key)}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
}
